export default "__VITE_ASSET__DpbV8i6N__"